// PC-角色用户列表
import request from '@/utils/request'

// 查询丝绵工序配置列表
export function apiOperationConfigCcList (data) {
  return request({
    url: '/bom/bomSmOperationConfigCc/list',
    method: 'post',
    data: data
  })
}

// 新增丝绵工序配置
export function apiOperationConfigCcAdd (data) {
  return request({
    url: '/bom/bomSmOperationConfigCc',
    method: 'post',
    data: data
  })
}

// 导出丝绵工序配置列表
export function apiOperationConfigCcExport (data) {
  return request({
    url: '/bom/bomSmOperationConfigCc/export',
    method: 'post',
    data: data
  })
}

// 修改丝绵工序配置
export function ApiOperationConfigCcEdit (query) {
  return request({
    url: '/bom/bomSmOperationConfigCc',
    method: 'put',
    data: query
  })
}
